import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../../../app.config';
import { PaymentService } from '../../../../services/payment.service';
import { HelpersService } from '../../../../services/helpers.service';
declare var Stripe: any;

@Component({
  selector: 'app-stripe-bundle-payment',
  templateUrl: './stripe-bundle-payment.component.html',
  styleUrls: ['./stripe-bundle-payment.component.scss'],
  providers: [MessageService]
})
export class StripeBundlePaymentComponent implements OnInit {

  @Input() bundle;
  @Input() country;
  public stripe: any;
  public card: any;
  public partner : any = {};
  public error : any = null;
  public busy : boolean = false;

  constructor(
    public modal: NgbActiveModal,
    public messageService: MessageService,
    public paymentService: PaymentService,
    public helpersService: HelpersService,
    private translate: TranslateService,
    private appConfig: AppConfig
  ) { }

  ngOnInit() {
    console.log(this.bundle);
    console.log(this.country);
    
    this.partner = this.helpersService.getPartnerData();

    this.stripe = Stripe(this.appConfig.getStripKey());

    var elements = this.stripe.elements();

    this.card = elements.create('card', {
      iconStyle: 'solid',
      style: {
        base: {
          iconColor: '#181818',
          color: '#181818',
          fontWeight: 500,
          fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
          fontSize: '16px',
          fontSmoothing: 'antialiased',

          ':-webkit-autofill': {
            color: '#181818'
          },
          '::placeholder': {
            color: '#777'
          }
        },
        invalid: {
          iconColor: '#d90028',
          color: '#181818'
        }
      }
    });
    this.card.mount('#card-input');   
  }

  submitPayment() {
    this.error = null;
    this.busy = true;
    this.stripe.createToken(this.card).then(tokenResult => {

      if (tokenResult.error) {
        this.error = tokenResult.error;
        this.busy = false;
      } else {        
        var paymentInfo = {
          PartnerID: this.partner.ID,
          PaymentProvider: 2, //Stripe
          TypeID: this.bundle.typeID,
          BundleID: this.bundle.id,
          Reference: this.partner.Name,
          Identifier: tokenResult.token.id+tokenResult.token.created          
        };
        this.paymentService.initializeHubtigerPayment(paymentInfo).subscribe(success => {
          var paymentData = {
              PartnerID : this.partner.ID,
              CardToken : tokenResult.token.id,
              Identifier: tokenResult.token.id+tokenResult.token.created,
              BundleID : this.bundle.id,
              Card: tokenResult.token.card
          }
          this.paymentService.stripeBundlePaymentComplete(paymentData).subscribe(paymentResult=>{            
            this.busy = false;
            this.modal.close(paymentResult);
          },err=>{
            this.busy = false;
            console.log(err);
            this.error = {message : err};
            this.messageService.add({life: 10000, detail: this.translate.instant('bikeshop.purchase-messaging-bundle.issue_stripe_payment')});
          });
        });
      }
    });
  }

}
